var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 8.828V37.74A2.259 2.259 0 0127.741 40H2.26A2.259 2.259 0 010 37.741V2.26A2.259 2.259 0 012.259 0h18.77L30 8.828z",
    fill: "#2B2BA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 12.427c-.845 0-2.257.332-3.585.7-1.36.375-2.73.819-3.535 1.088a1.886 1.886 0 00-.862.6 1.96 1.96 0 00-.417.977c-.73 5.597.964 9.744 3.019 12.488a14.567 14.567 0 003.082 3.066c.472.341.91.602 1.283.781.343.165.712.3 1.015.3.304 0 .671-.135 1.015-.3a8.725 8.725 0 001.283-.781 14.56 14.56 0 003.082-3.066c2.055-2.744 3.749-6.892 3.019-12.488a1.947 1.947 0 00-.417-.977 1.886 1.886 0 00-.861-.601 75.27 75.27 0 00-3.536-1.088c-1.328-.366-2.74-.699-3.585-.699z",
    fill: "#7427EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18.142a1.754 1.754 0 01.584 3.407l.45 2.326a.583.583 0 01-.573.695h-.921a.584.584 0 01-.573-.695l.449-2.326A1.753 1.753 0 0130 18.142z",
    fill: "#fff"
  })));
}
export default SvgDataSecurity;